export const state = () => ({
  jobLpData: {}
})

export const mutations = {
  SET_JOB_LP_DATA(state, payload) {
    state.jobLpData = payload
  }
}
export const actions = {
  saveJobLpData({ commit }, jobData) {
    commit('SET_JOB_LP_DATA', jobData)
  }
}
export const getters = {
  jobLpData: (state) => state.jobLpData
}
